import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { selectDidomiUserStatus } from 'store/config/selectors.ts';

import usePrivacyPolicyParams from 'services/uav/usePrivacyPolicyParams.ts';
import { logUavAnalytics } from 'services/uav/utils.ts';

function useConsentSelectionChange() {
    const didomiUserStatus = useSelector(selectDidomiUserStatus);
    const { getPrivacyPolicyUavParams } = usePrivacyPolicyParams();

    const prevDidomiUserStatus = useRef(didomiUserStatus);

    useEffect(() => {
        if (
            didomiUserStatus &&
            didomiUserStatus.updated !== prevDidomiUserStatus.current?.updated
        ) {
            logUavAnalytics(
                getPrivacyPolicyUavParams(JSON.stringify([didomiUserStatus])),
            );
        }

        prevDidomiUserStatus.current = didomiUserStatus;
    }, [didomiUserStatus]);
}

export default useConsentSelectionChange;
